import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ReportDailyTransactionsService extends GenericService {
    constructor() {
        super('/reports/daily_transactions', axiosInstance);
    }
}

export default new ReportDailyTransactionsService();